<!-- <div class="credit-withdraw-content-container" *ngIf="isOpen"> -->
<div class="credit-withdraw-content-container">
  <div class="pay3000-container-main text">
    <!-- <ng-container *ngIf="false"> -->
    <ng-container *ngIf="isInitial">
      <div class="pay3000-container-item">
        {{ 'pay3000_text1' | t }}
      </div>
      <!-- <div class="pay3000-container-item">
            {{ "pay3000_text2" | t }}
          </div> -->
      <div class="credit-input-container" style="width: 100%">
        <form class="change-password-form" [formGroup]="pay3000Form" *ngIf="true">
          <div class="input-container-pay3000">
            <!-- <input style="width: 100%; height: 35px;"
              type="text" placeholder="Pay3000 Customer ID"> -->

            <inputb3 [extraClass]="'amountInput'" fInputType="text" formControlName="pay3000Id" fPlaceholder="{{ 'arenaPay_text1' | t }}"></inputb3>
          </div>

          <ng-container>
            <div class="form-b3 form-field-b3 checkbox">
              <label for="agreement" class="label-b3">
                <div class="text-1">
                  {{ 'b3000_Pay3000_checkbox_text_5' | t }}
                  <a class="text-1" style="text-decoration: underline; font-weight: bold; color: #000" routerLink="/article/{{ 'route_article_footer_5' | t }}" target="_blank"
                    >AGB
                  </a>
                  <a class="text-1">
                    {{ 'b3000_Register_checkbox_text_8' | t }}
                  </a>
                  <a class="text-1" style="text-decoration: underline; font-weight: bold; color: #000" routerLink="/article/{{ 'route_article_footer_4' | t }}" target="_blank"
                    >{{ 'footer_privacy_cookies' | t }}.</a
                  >
                </div>

                <!-- <div class="text-1">
                    {{ "b3000_Register_checkbox_text_7" | t }}
                  </div> -->
              </label>
              <div class="input-container checkbox">
                <input class="formType_checkbox" type="checkbox" id="agreement" name="agreement" required="isRequired" formControlName="terms_and_condition" />
              </div>
            </div>
          </ng-container>

          <!-- <ng-container>
              <inputb3
                formControlName="terms_and_condition"
                fPlaceholder="{{ 'pay3000_text2' | t }}"
                fInputType="checkbox"
              ></inputb3>

            </ng-container> -->
          <div class="">
            <ng-template #noValid>
              <div class="btn colored green save-changes-button confirm-button" style="opacity: 0.5">
                <div class="btn-text" style="color: #fff !important">
                  {{ 'pay3000_text5' | t }}
                </div>
              </div>
            </ng-template>
            <div *ngIf="pay3000Form.valid; else noValid" class="btn colored green save-changes-button confirm-button" (click)="registerButton()">
              <div class="btn-text" style="color: #fff !important">
                {{ 'arenaPay_text2' | t }}
              </div>
            </div>
          </div>
        </form>

        <div
          *ngIf="errorMessage"
          class="error-message"
          style="font-size: 14px; color: #be1717; font-weight: 600; padding-left: 10px; font-family: Source Sans Pro; line-height: 1.5">
          {{ 'pay3000_text9' | t }}

          <!-- <span
                style="text-decoration: underline; color: #2e5084"
                (click)="requestNewOne()"
              >
                Request a new one.
              </span>
              <p style="text-decoration: underline; color: #2e5084">
                <a href="mailto:support@WettArena.de" style="color: #2e5084">
                  If you are having trouble please contact support.
                </a>
              </p> -->
        </div>
        <div class="sub-container-pay3000">
          <div class="sub-item-row">
            {{ 'arenaPay_text2' | t }}
          </div>
          <div class="sub-item-row">
            {{ 'pay3000_text7' | t }}
            <a style="color: orange" href="https://apps.apple.com/us/app/WettArena-pay/id1479520646" target="_blank">{{ 'arenaPay_text3' | t }}</a>
            <!-- <u >{{ "pay3000_text8" | t }}</u> -->
            {{ 'pay3000_text11' | t }}
          </div>

          <div class="sub-item-row">
            {{ 'pay3000_text7' | t }}
            <a style="color: orange" href="https://play.google.com/store/apps/details?id=com.oktopay.pay3000" target="_blank">{{ 'arenaPay_text4' | t }}</a>
            <!-- <u >{{ "pay3000_text8" | t }}</u> -->
            {{ 'pay3000_text11' | t }}
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isInitialSuccess">
      <div class="pay3000-success-container">
        <div class="pay3000-success-container-item" style="align-items: center">
          <div class="left-side" style="display: flex; flex: 1; align-items: center">
            {{ 'arenaPay_text5' | t }}
            <span style="font-weight: bold">
              {{ this.pay3000Customer?.Data?.customerAccountNumber }}
            </span>
          </div>
          <div class="right-side" style="margin-left: 10px">
            {{ 'b3000_pay3000_text2' | t }}
            <span style="font-weight: bold"> {{ this.pay3000Customer?.Data?.status }}</span>
          </div>
        </div>
        <div class="pay3000-success-container-item">
          {{ 'pay3000_text12' | t }}
        </div>

        <div (click)="confirmButton()" class="btn colored register-button save-changes-button confirm-button green">
          <div class="btn-text" style="color: #fff !important">
            {{ 'pay3000_text5' | t }}
          </div>
        </div>

        <div
          *ngIf="errorMessage2"
          class="error-message"
          style="font-size: 14px; color: #be1717; font-weight: 600; padding-left: 10px; font-family: Source Sans Pro; line-height: 1.5">
          {{ 'pay3000_text13' | t }}
          <!-- <span
                style="text-decoration: underline; color: #2e5084"
                (click)="requestNewOne()"
              >
                Request a new one.
              </span>
              <p style="text-decoration: underline; color: #2e5084">
                <a href="mailto:support@WettArena.de" style="color: #2e5084">
                  If you are having trouble please contact support.
                </a>
              </p> -->
        </div>
        <div *ngIf="errorMessage2">
          {{ 'arenaPay_text14' | t }}
          <a
            href="mailto:support@wettarena.com?Subject=ArenaPay/{{ this.pay3000Customer?.Data?.customerAccountNumber }}/{{ this._UserHelper?.customerUser.UserName }}"
            style="color: #212529; font-weight: 800; margin-left: 5px">
            {{ 'b3000_pay3000_text9' | t }}
          </a>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isConfirmed">
      <!-- <ng-container  *ngIf="true"> -->

      <div class="pay3000-success-container">
        <div class="pay3000-success-container-item" style="align-items: center">
          <div class="left-side" style="display: flex; flex: 1; align-items: center">
            {{ 'arenaPay_text5' | t }}
            <b>{{ this.pay3000Customer?.CustomerAccountNumber }}</b>
          </div>
          <div class="right-side" style="margin-left: 10px">
            {{ 'b3000_pay3000_text2' | t }} <b>{{ this.pay3000Customer?.Statu }}</b>
          </div>
        </div>
        <div class="pay3000-success-container-item">
          {{ 'b3000_pay3000_text3' | t }} {{ this.pay3000Customer?.Balance }} {{ this._UserHelper.customerUser?.Symbol }} {{ 'arenaPay_text6' | t }}
          <!-- You have {{ this.pay3000Customer?.Balance }} EUR in your pay3000
          Gaming wallet to find out more about wagering requirements. -->
        </div>
        <div class="pay3000-success-container-item">
          {{ 'b3000_pay3000_text5' | t }}
          <a
            href="mailto:support@wettarena.com?Subject=ArenaPay/{{ this.pay3000Customer?.Data?.customerAccountNumber }}/{{ this._UserHelper?.customerUser.UserName }}"
            style="color: #212529; font-weight: 800; margin-left: 5px">
            {{ 'b3000_pay3000_text9' | t }}
          </a>
        </div>
        <div class="pay3000-success-container-item">
          {{ 'arenaPay_text2' | t }}

          {{ this.pay3000Customer?.CreateDate | dateFormat : 'dd.MM.yyyy' }}
          {{ 'b3000_pay3000_text7' | t }}
        </div>
        <ng-template #noData>
          <div class="btn colored register-button save-changes-button confirm-button" style="opacity: 0.5">
            <div class="btn-text">{{ 'Revoke' | t }}</div>
          </div>
        </ng-template>
        <div *ngIf="this.pay3000Customer && !isRevokeConfirm; else noData" (click)="isRevokeConfirmation()" class="btn colored register-button save-changes-button confirm-button">
          <div class="btn-text">{{ 'Revoke' | t }}</div>
        </div>

        <div class="revoke-confirmation-container" *ngIf="isRevokeConfirm">
          <div class="pay3000-success-container-item" style="font-weight: 600">
            {{ 'b3000_pay3000_text8' | t }}
          </div>
          <div style="display: flex">
            <div (click)="revokePay3000()" class="btn colored green register-button save-changes-button confirm-button">
              <div class="btn-text">{{ 'Yes' | t }}</div>
            </div>
            <div (click)="isRevokeConfirmation()" class="btn colored error register-button save-changes-button confirm-button">
              <div class="btn-text">{{ 'No' | t }}</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
